const SidebarDesktop = ({ links, children }) => {
  return (
    <div className="hidden w-64 h-full bg-gray-800 text-white shadow-lg md:flex flex-col py-6 px-3 z-10">
      <div className="flex items-center gap-4 pb-4 border-b border-gray-600 mb-4">
        {children}
      </div>
      <ul className="flex flex-col gap-3 w-full pr-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-transparent">
        {links}
      </ul>
    </div>
  );
};

export default SidebarDesktop;
